var _path, _g, _g2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficSignExitOnlyNar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "traffic_x5F_sign_x5F_exit_x5F_only_x5F_nar_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "traffic_x5F_sign_x5F_exit_x5F_only_x5F_nar"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2B236"
    },
    d: "M90,69H6c-2.209,0-4-1.791-4-4V31c0-2.209,1.791-4,4-4h84c2.209,0,4,1.791,4,4v34 C94,67.209,92.209,69,90,69z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90,31v34H6V31H90 M90,29H6c-1.105,0-2,0.895-2,2v34c0,1.105,0.895,2,2,2h84c1.105,0,2-0.895,2-2V31 C92,29.895,91.105,29,90,29L90,29z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.2,43h5.172v1.344h-3.696v2.268h3.408v1.248h-3.408v2.496h3.696v1.188H11.2V43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.708,47.2L17.272,43h1.62l1.776,2.988L22.42,43h1.476l-2.436,4.2l2.508,4.344H22.36l-1.848-3.132l-1.836,3.132H17.2 L19.708,47.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.868,43h1.476v8.544h-1.476V43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4,43h6.312v1.344H31.3v7.2h-1.476v-7.2H27.4V43z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.559,51.688c-0.681,0-1.242-0.074-1.687-0.222s-0.798-0.396-1.062-0.743c-0.265-0.349-0.449-0.807-0.553-1.375 c-0.104-0.568-0.156-1.272-0.156-2.112c0-0.848,0.057-1.554,0.168-2.118c0.112-0.564,0.303-1.014,0.57-1.35 s0.622-0.572,1.062-0.708c0.439-0.136,0.991-0.204,1.656-0.204c0.655,0,1.203,0.068,1.643,0.204 c0.44,0.136,0.795,0.372,1.062,0.708s0.458,0.786,0.57,1.35c0.111,0.564,0.168,1.27,0.168,2.118c0,0.84-0.053,1.544-0.156,2.112 c-0.104,0.568-0.286,1.026-0.546,1.375c-0.26,0.348-0.612,0.596-1.056,0.743C64.8,51.613,64.238,51.688,63.559,51.688z  M63.559,50.5c0.391,0,0.711-0.038,0.959-0.114c0.248-0.075,0.439-0.229,0.576-0.462c0.137-0.232,0.23-0.562,0.282-0.99 c0.052-0.428,0.078-0.998,0.078-1.71c0-0.632-0.026-1.146-0.078-1.542s-0.146-0.704-0.282-0.924 c-0.137-0.22-0.328-0.368-0.576-0.444S63.949,44.2,63.559,44.2c-0.4,0-0.725,0.038-0.973,0.114s-0.442,0.224-0.582,0.444 c-0.141,0.22-0.234,0.528-0.282,0.924s-0.071,0.91-0.071,1.542c0,0.712,0.023,1.282,0.071,1.71 c0.048,0.428,0.142,0.758,0.282,0.99c0.14,0.232,0.334,0.387,0.582,0.462C62.834,50.462,63.158,50.5,63.559,50.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.346,43h1.452l3.444,5.808V43h1.416v8.544h-1.465l-3.443-5.808v5.808h-1.404V43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.361,43h1.477v7.355h3.624v1.188h-5.101V43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.406,48.22l-2.7-5.22h1.608l1.943,3.672L86.178,43h1.416l-2.699,5.22v3.324h-1.488V48.22z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.21,45.837c-0.249,0.019-0.509,0.039-0.725,0.104l-3.987,0.733h-0.947V41h-5v5.673h-1.362L40.06,45.94 c-0.217-0.064-0.475-0.092-0.725-0.104c-0.806-0.038-1.462,0.352-1.462,0.783c0,0.202,0.154,0.401,0.411,0.544L48,54l9.26-6.837 c0.257-0.143,0.411-0.342,0.411-0.544C57.671,46.188,56.961,45.779,56.21,45.837z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficSignExitOnlyNar);
export default __webpack_public_path__ + "static/media/icon-traffic_sign_exit_only_nar.acf833d4bba3628c16d856b3b118755d.svg";
export { ForwardRef as ReactComponent };